import { render, staticRenderFns } from "./DemoWidget.vue?vue&type=template&id=dd21035e&scoped=true&lang=html&"
import script from "./DemoWidget.vue?vue&type=script&lang=js&"
export * from "./DemoWidget.vue?vue&type=script&lang=js&"
import style0 from "./DemoWidget.vue?vue&type=style&index=0&id=dd21035e&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd21035e",
  null
  
)

export default component.exports